import React, { useContext } from 'react';

import { OptimizelyProvider, createInstance } from '@optimizely/react-sdk';

import clientConfig from '../../client/config';
import { AuthContext } from '../../context/AuthContext';
import { usePageMeta } from '../../hooks';
import useBasePageQuery from '../../hooks/useBasePageQuery';
import { filterByTypename } from '../../utils/graphql';

export const CustomOptimizelyProvider: React.FunctionComponent = ({
  children,
}) => {
  const auth = useContext(AuthContext);
  const { pageType } = usePageMeta();
  const isSSR = typeof window === 'undefined';
  const userId = auth?.loggedOutGuid ?? null;
  const basePageData = useBasePageQuery();
  const env = process.env.K8S_NAMESPACE || process.env.ENV || 'dev';

  const charity = basePageData.data?.page?.relationships?.beneficiaries?.nodes
    ? filterByTypename(
        basePageData.data?.page?.relationships?.beneficiaries?.nodes,
        'Charity',
      )
    : null;
  const charityId = charity?.[0]?.legacyId;
  const hasCharityColourOnFrp = Boolean(
    basePageData.data?.page?.branding?.primaryColor,
  );

  const attributes = {
    charityId: charityId ?? '',
    pageType: pageType?.toLocaleLowerCase(),
    hasCharityColourOnFrp,
  };

  const optimizelyInstance = createInstance({
    sdkKey: clientConfig.optimizelyFullstackKey,
    logLevel: env === 'production' ? 'info' : 'debug',
  });

  return (
    <OptimizelyProvider
      optimizely={optimizelyInstance}
      isServerSide={isSSR}
      // Due to heavy caching we can only enrol users on the client
      user={{ id: !isSSR ? userId : null, attributes }}
    >
      {children}
    </OptimizelyProvider>
  );
};
